export default "__VITE_ASSET__DM33HU3n__"